export const handleFormatCep = (value: string) => {
  const newCep = value.replace(/\D/g, "");

  const maskedCep = newCep.slice(0, 8).replace(/(\d{5})(\d{3})/, "$1-$2");

  return maskedCep;
};
